import React from 'react';
import { BedIcon, BathIcon, AreaIcon, HomeIcon, CalendarIcon, InfoIcon } from '../Icons/Icons';
import './PropertyOverview.css';

function PropertyOverview({ property }) {
  const overviewItems = [
    {
      icon: <BedIcon size={24} color="var(--color-primary)" />,
      label: 'Bedrooms',
      value: property.beds
    },
    {
      icon: <BathIcon size={24} color="var(--color-primary)" />,
      label: 'Bathrooms',
      value: property.baths
    },
    {
      icon: <AreaIcon size={24} color="var(--color-primary)" />,
      label: 'Area',
      value: property.area
    },
    {
      icon: <HomeIcon size={24} color="var(--color-primary)" />,
      label: 'Type',
      value: property.type
    },
    {
      icon: <CalendarIcon size={24} color="var(--color-primary)" />,
      label: 'Posted',
      value: property.postedDate
    },
    {
      icon: <InfoIcon size={24} color="var(--color-primary)" />,
      label: 'Property ID',
      value: property.id
    }
  ];

  return (
    <div className="property-overview">
      <h2 className="section-title">Property Overview</h2>

      <div className="overview-grid">
        {overviewItems.map((item, index) => (
          <div key={index} className="overview-item">
            <div className="overview-icon">{item.icon}</div>
            <div className="overview-content">
              <div className="overview-label">{item.label}</div>
              <div className="overview-value">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PropertyOverview;
